function init() {

    $(".location-switch").change(function () {
        $(".view-container, .location-person").show();
        var $switcher = $(this),
            $views = $(".views-row"),
            val = $switcher.val();

        if (val !== "location-all") {
            $views.find("> div:not(." + val + ")").hide();
            $views.find("." + val).show();
        } else {
            $views.find("div").show();
        }
    });
}

export default {
    init
}